import { Field } from 'formik';
import React from 'react';
import { Input } from 'components/atoms';

interface ISwitchInputProps {
  name: string;
  [key: string]: any;
  label: string;
}

const SwitchElem: React.FC<ISwitchInputProps> = ({
  name,
  label,
  ...props
}) => {
  return (
    <div className="flex gap-2 items-center">
      <Field name={name}>
        {({ field, form }: any) => (
          <Input.Switch
            checked={field.value}
            label={label}
            onChange={(checked: boolean) => form.setFieldValue(name, checked)}
            {...props}
          />
        )}
      </Field>
    </div>
  );
};

export default SwitchElem;
